<template>
  <aside class="block overflow-hidden bg-white border rounded">
    <div class="border-b border-ricoma-gray-300">
      <img
        class="object-contain object-center w-full h-full"
        src="../../assets/decosummit-logo.webp"
        alt="ad"
      />
    </div>
    <div class="px-4 py-4">
      <h6 class="mb-4 font-bold text-center">
        {{ $t('dashboard.decosummit.title') }}
      </h6>
      <p class="mb-4 text-center text-xl font-bold" style="color: #3936e3">DECO20</p>
      <p class="mb-4 text-center">
        {{ $t('dashboard.decosummit.content') }}
      </p>
      <a
        href="https://www.decosummit.com/register"
        target="_blank"
        class="cursor-pointer button-decosummit font-bold"
        style=""
      >
        {{ $t('dashboard.decosummit.link') }}
        <VSvgIcon name="arrow-right" class="ml-2" />
      </a>
    </div>
  </aside>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'DashboardDecosummitAdCard',
  props: {},
  components: { VSvgIcon },
};
</script>
